import React, { useState } from "react";
import OwlCarousel from "react-owl-carousel";
import "owl.carousel/dist/assets/owl.carousel.css";
import "owl.carousel/dist/assets/owl.theme.default.css";
import "./style.css";
import { reviews } from "../../script";
import googleRev from "../../assets/img/Google-Review.png";

export default function Testimonials () {
  const [modalContent, setModalContent] = useState(null);
  const closeModal = () => setModalContent(null);

  return (
    <section className="google-reviews">
      <h2
        className="section-header"
        data-aos="zoom-in"
        data-aos-duration="1500"
      >
        What Our Customers Say
      </h2>

      <div className="review-header" data-aos="zoom-in" data-aos-duration="1500">
        <div className="review-summary">
          <img src={googleRev} alt="Google" className="google-icon" />
          <div className="review-score">
            <strong>4.5</strong>
            <span className="stars">★★★★★</span>
            <span className="review-count">(148)</span>
          </div>
        </div>
        <div>
          <a
            href="https://www.google.com/maps/place//data=!4m3!3m2!1s0x548670f2acf0caf5:0xa180b9dfb101ef53!12e1?source=g.page.m.kd._&laa=lu-desktop-review-solicitation"
            className="review-btn"
          >
            Reviews Us On Google
          </a>
          <a
            href="https://homestars.com/companies/198943-bur-han-garden-lawn-care"
            className="review-btn"
          >
            HomeStars Reviews
          </a>
        </div>
      </div>

      <OwlCarousel
        className="review-carousel owl-theme"
        data-aos="zoom-in" data-aos-duration="1500"
        loop
        margin={20}
        autoplay
        autoplayTimeout={5000}
        smartSpeed={600}
        dots
        responsive={{
          0: { items: 2 },
          300: { items: 2 },
          400: { items: 2 },
          561: { items: 3 },
          992: { items: 4 },
          1200: { items: 5 },
        }}
      >
        {reviews.map((review, index) => {
          const isLong = review.comment.length > 150;
          const preview = isLong
            ? review.comment.slice(0, 150) + "..."
            : review.comment;

          return (
            <div className="review-card" key={index}>
              <div className="review-name">
                <div>
                  <strong>{review.name}</strong>
                  <br />
                </div>
              </div>
              <div className="stars">{"★".repeat(review.rating)}</div>
              <div className="review-text">{preview}</div>
              {isLong && (
                <button
                  className="read-more"
                  onClick={() => setModalContent(review)}
                >
                  Read more
                </button>
              )}
            </div>
          );
        })}
      </OwlCarousel>

      {modalContent && (
        <div className="review-modal" onClick={closeModal}>
          <div className="modal-content">
            <div className="modal-header">
              <strong>{modalContent.name}</strong>
            </div>
            <div className="stars" style={{ float: "left" }}>
              {"★".repeat(modalContent.rating)}
            </div>
            <p className="modal-comment">{modalContent.comment}</p>
          </div>
        </div>
      )}
    </section>
  );
}
